import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getAppAdminTrainingTopicSlice = createApi(`GetAppAdminTrainingTopicSlice`, "GET");

const GetAppAdminTrainingTopicSlice = createSlice({
  name: 'GetAppAdminTrainingTopicSlice',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAppAdminTrainingTopicSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAppAdminTrainingTopicSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAppAdminTrainingTopicSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default GetAppAdminTrainingTopicSlice.reducer;
